export default {
  error: 0,
  warn: 1,
  log: 2,
  info: 3,
  debug: 4,
  trace: 5
};